import { Info } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

interface DocumentUploadHelpBannerProps {
    businessType?: string;
}

const DocumentUploadHelpBanner = ({ businessType }: DocumentUploadHelpBannerProps) => {
    const subText =
        'Proof of Bank(s) (Settlement & chargeable if separate & Outlet if different), All Principals that are listed below need to have Proof of ID & Proof of Address, B1 Form and Business Report';
    const subTextSoleProp =
        'Proof of Bank(s) (Settlement & chargeable if separate & Outlet if different), All Principals that are listed below need to have Proof of ID & Proof of Address and Business Report';

    const subTextPartnership =
        'Partnership Deed, Proof of Bank(s) (Settlement & chargeable if separate & Outlet if different), All Principal’s that are listed below need to have Proof of ID & Proof of Address and Business Report';

    const selectedBusinessTypes = {
        PRIVATE_LIMITED_COMPANY: {
            title: 'Private Limited Company - LTD',
            subText,
        },
        PUBLIC_LIMITED_COMPANY: {
            title: 'Public Limited Company - PLC',
            subText,
        },
        LIMITED_LIABILITY_PARTNERSHIP: {
            title: 'Limited Liability Partnership - LLP',
            subText,
        },
        PARTNERSHIP: {
            title: 'Partnership',
            subText: subTextPartnership,
        },
        SOLE_TRADER: {
            title: 'Sole Trader',
            subText: subTextSoleProp,
        },
    };

    return businessType ? (
        <Stack width="100%" bgcolor="#b9f6ca" borderRadius="16px" padding="24px 48px">
            <Stack width="100%" flexDirection="row" justifyContent="flex-start">
                <Info />
                <Stack p={0.5} />
                <Stack justifyContent="flex-start" alignItems="baseline">
                    <Stack p={0.3} />
                    <Typography>
                        For Business Type&nbsp;
                        <Typography component="span" fontWeight="bold">
                            {selectedBusinessTypes[`${businessType}`].title},&nbsp;
                        </Typography>
                        the following documents must be uploaded before the application can be sent
                        to the Acquirer
                    </Typography>

                    <Stack p={0.8} />

                    <Typography p={0} m={0} fontWeight="bold">
                        {selectedBusinessTypes[`${businessType}`].subText}
                    </Typography>

                    <Stack p={0.8} />

                    <Typography p={0} m={0} fontWeight="bold">
                        *Any supporting documents that were highlighted in Step 2 after selecting
                        the MCC will also need to be uploaded as &apos;Other&apos;
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    ) : null;
};
export default DocumentUploadHelpBanner;
